export enum QueryKeysEnum {
  INVITED_USERS = "invitedUsers",
  ME = "me",
  WORKSPACE = "workspace",
  REQUESTS = "requests",
  PROPOSALS = "proposals",
  NOTIFICATIONS = "notifications",
}
